module.exports = __webpack_public_path__ + "static/media/368.aec2cfa7.svg";